export type IdKeyValueType = {
  id: string
  key: string
  value: string
}

export type ThemeVariableObj = {
  name: string
  description: string
  value: string
  type: VariableTypeEnum
}

export type ChangeThemeVariableEventHandler = ({name, value}: Pick<ThemeVariableObj, 'name' | 'value'>) => void

export interface EditableNameValueProps extends ThemeVariableObj {
  onChange?: ChangeThemeVariableEventHandler
}

export enum VariableTypeEnum {
  NONE = 'NONE', // not defined type
  COLOR = 'COLOR', // any color type
  FILE = 'FILE', // file reference (upload)
  REFERENCE = 'REFERENCE', // reference to another variable
  DIMENSION = 'DIMENSION', // px, em ... values
  INDEX = 'INDEX', // values with dropdown usage
}